module.exports = __webpack_public_path__ + "img/D201503_2.39bcb9b5.jpg";